<template>
  <!-- TODO: This whole component can be simplified -->
  <div class="candidate works-and-study-rights signup-prompt">
    <!-- Loading -->
    <SpeechBubble :avatar="logo" v-if="!ready" :loading="loading" color="white" />

    <Conversation
      v-if="ready"
      v-model="conversation"
      @scroll="$emit('scroll')"
      @done="$emit('done')"
    />
  </div>
</template>

<script>
// Components
import SpeechBubble from '@/components/prompts/SpeechBubble'
import Conversation from '@/components/prompts/Conversation'

// Helpers
import { mapGetters } from 'vuex'

export default {
  components: { SpeechBubble, Conversation },

  created() {
    this.initialize()
  },

  props: {
    loading: { type: Boolean, default: false },
    profile: { type: Object },
  },

  data() {
    return {
      ready: !this.loading,
      conversation: [],
    }
  },

  computed: {
    ...mapGetters({ campaign: 'campaign/model' }),

    isOrganizationCampaign() {
      return !!(this.campaign && this.campaign.organization)
    },

    isOpportunityCampaign() {
      return !!(this.campaign && this.campaign.opportunity)
    },

    campaignOrganization() {
      if (this.isOrganizationCampaign) return this.campaign.organization
      if (this.isOpportunityCampaign) return this.campaign.opportunity.organization
    },

    logo() {
      if (this.campaignOrganization) return this.campaignOrganization.logo

      return '/img/leaply-rainbow-square.png'
    },

    buttonText() {
      if (this.isOpportunityCampaign) return 'View opportunity'
      return 'View all opportunities'
    },

    directTo() {
      if (this.isOrganizationCampaign) return `/organizations/${this.campaign.organization.id}`
      if (this.isOpportunityCampaign) return `/opportunities/${this.campaign.opportunity.id}`
      return '/opportunities'
    },
  },

  watch: {
    loading(value) {
      if (!value) this.ready = true
    },
  },

  methods: {
    initialize() {
      this.conversation = [
        {
          key: 0,
          type: 'prompt',
          text: 'finalPrompt04',
          buttons: [
            { text: 'Yes', next: 1, block: true }
          ],
        },
        {
          key: 1,
          type: 'response',
          text: 'finalResponse01',
          next: 2,
        },
        {
          key: 2,
          text: 'finalPrompt01',
          type: 'prompt',
          next: 3,
        },
        {
          key: 3,
          text: 'finalPrompt02',
          type: 'prompt',
          next: 4,
        },
        {
          key: 4,
          text: 'finalPrompt03',
          type: 'prompt',
          buttons: [
            {
              text: this.buttonText,
              onClick: () => {
                this.$router.push(this.directTo)
                this.$emit('close')
              },
            },
          ],
        },
      ]
    },
  },
}
</script>
